import { useCallback, useMemo } from 'react';

import { useClient } from 'urql';
import { fromPromise } from 'xstate5';

import { CustomerDocument } from '../../graphql/customer.generated';

import type { CustomerQuery } from '../../graphql/customer.generated';
import type { CurrentCustomerContextData } from '../../setup';

// ─────────────────────────────────────────────────────────────────────────────

export const useFetchCustomerActor = () => {
  const client = useClient();

  const fetchCustomer = useCallback(async (): Promise<CurrentCustomerContextData> => {
    const response = await client
      .query<CustomerQuery>(CustomerDocument, {}, { requestPolicy: 'network-only' })
      .toPromise();
    const { currentCustomer } = response.data ?? {};

    const hasFailedToFetchCustomerData = response.error !== undefined || !currentCustomer;

    if (hasFailedToFetchCustomerData) {
      throw new Error('Failed to get customer data!');
    }

    return currentCustomer;
  }, [client]);

  return useMemo(() => {
    return fromPromise<CurrentCustomerContextData>(async () => fetchCustomer());
  }, [fetchCustomer]);
};
